export const categories = [
  { id: "food", name: "Food", icon: "🍔" },
  { id: "transportation", name: "Transportation", icon: "🚗" },
  { id: "entertainment", name: "Entertainment", icon: "🎬" },
  { id: "utilities", name: "Utilities", icon: "💡" },
  { id: "healthcare", name: "Healthcare", icon: "🩺" },
  { id: "education", name: "Education", icon: "🎓" },
  { id: "travel", name: "Travel", icon: "✈️" },
  { id: "salary", name: "Salary", icon: "💰" },
  { id: "shopping", name: "Shopping", icon: "🛍️" },
  { id: "subscriptions", name: "Subscriptions", icon: "📺" },
  { id: "rent", name: "Rent", icon: "🏠" },
  { id: "groceries", name: "Groceries", icon: "🛒" },
  { id: "debt_payments", name: "Debt Payments", icon: "💳" },
  { id: "investments", name: "Investments", icon: "📈" },
  { id: "donations", name: "Donations", icon: "❤️" },
  { id: "miscellaneous", name: "Miscellaneous", icon: "🧩" },
  { id: "transfer", name: "Transfer", icon: "🔄" },
];
